import { AxiosInstance } from 'axios';
import { CategoriesRepository } from '@/model/repository/manager/categories/CategoriesRepository';

export default (Repository: AxiosInstance) =>
  (resource: string): CategoriesRepository => ({
    index(payload) {
      return Repository.get(`${resource}`, { params: payload });
    },
  });
